import { combineReducers } from 'redux'
import account from './account'
import campers from './campers'
import parents from './parents'
import pickupPeople from './pickupPeople'
import emergencyContacts from './emergencyContacts'
import forms from './forms'
import cart from './cart'
import checkout from './checkout'
import modal from './modal'
import errorMessage from './errorMessage'
import notifications from './notifications'
import billing from './billing'

const rootReducer = combineReducers({
  account,
  campers,
  parents,
  pickupPeople,
  emergencyContacts,
  forms,
  cart,
  checkout,
  modal,
  errorMessage,
  notifications,
  billing
})

export default rootReducer
